import { TOKEN_RE } from '../../../shared/limits';

// 사람 아이디(pid)와 비밀 토큰: 브라우저 저장소에 둔다. 서버는 토큰을 해시로만 가진다(v2 architecture-review 4.4).
// 저장소를 못 쓰면 이 페이지가 열려 있는 동안만 기억한다(재접속은 같은 사람, 새로 열면 새 사람)
const KEY = 'leaf-town-v3.player';
let pid: string | undefined, token: string | undefined;

export function loadIdentity() {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) as string);
    if (v && typeof v.token === 'string' && TOKEN_RE.test(v.token)) { token = v.token; pid = typeof v.pid === 'string' ? v.pid : undefined; }
  } catch (e) { /* 저장소 없음 */ }
}

export const joinToken = () => token;
export const myPid = () => pid;

// welcome에서 받은 값을 기억한다. token은 새로 발급했을 때만 온다
export function rememberIdentity(newPid?: string, newToken?: string) {
  if (typeof newToken === 'string' && TOKEN_RE.test(newToken)) token = newToken;
  if (typeof newPid === 'string') pid = newPid;
  try { if (token) localStorage.setItem(KEY, JSON.stringify({ pid, token })); } catch (e) { /* 저장소 없음 */ }
}
